var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup67(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28.832,
    viewBox: "0 0 32 28.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(942.525 -1371.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M-919.358,1378.427a7.62,7.62,0,0,1-1.2,3.961q-2.7,4.211-5.389,8.426a.848.848,0,0,1-.616.479.776.776,0,0,1-.8-.413q-1.594-2.5-3.2-5-1.134-1.775-2.265-3.549a7.112,7.112,0,0,1-1.091-4.71,7.213,7.213,0,0,1,5.913-6.35,7.251,7.251,0,0,1,8.441,5.639C-919.461,1377.41-919.425,1377.922-919.358,1378.427Zm-12.12-.006a4.789,4.789,0,0,0,4.8,4.808,4.8,4.8,0,0,0,4.8-4.788,4.81,4.81,0,0,0-4.816-4.8A4.8,4.8,0,0,0-931.478,1378.421Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M-929.832,1399.982c-.181-1.424-.356-2.815-.536-4.207-.018-.142.021-.193.166-.22,2.228-.424,4.453-.856,6.68-1.282q3.576-.684,7.152-1.362c1.219-.233,2.436-.474,3.655-.71.046-.009.093-.009.15-.015.357.808.711,1.608,1.063,2.409.253.575.507,1.15.756,1.728a2.6,2.6,0,0,1-2.393,3.658q-8.22,0-16.441,0Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M-931.725,1394.619l-10.779,2.067c.055-.161.087-.281.136-.393q2.246-5.117,4.5-10.233a2.561,2.561,0,0,1,2.531-1.655c.712,0,1.425.005,2.137,0,.174,0,.224.048.243.226.094.847.208,1.693.314,2.54.1.822.2,1.645.3,2.468.106.846.214,1.692.319,2.538C-931.924,1392.979-931.827,1393.785-931.725,1394.619Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M-914.8,1387.08l1.738,3.957c-.435.086-.852.169-1.27.249l-4.876.932q-.8.153-1.592.313a.2.2,0,0,1-.258-.132q-.826-1.958-1.665-3.91a1.138,1.138,0,0,1-.039-.147Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M-942.525,1397.921l10.951-2.1.519,4.149c-.081,0-.157.011-.233.011q-4.357,0-8.715,0a2.6,2.6,0,0,1-2.515-1.945A.692.692,0,0,1-942.525,1397.921Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M-922.2,1392.794l-8.33,1.6-.95-7.62.037-.017c.258.4.518.795.774,1.194q1.172,1.833,2.343,3.667a1.944,1.944,0,0,0,3.25.056c.489-.717.944-1.458,1.443-2.234Z",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M-915.337,1385.941l-6.738,1.067c.141-.229.266-.435.4-.637.387-.6.772-1.21,1.169-1.807a.373.373,0,0,1,.256-.153c.935-.008,1.873-.035,2.8.013a2.477,2.477,0,0,1,2.09,1.4A.4.4,0,0,1-915.337,1385.941Z",
    fill: "#586973"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup67);
export default __webpack_public_path__ + "static/media/Group 67.9c565b97.svg";
export { ForwardRef as ReactComponent };